import { connect } from 'react-redux';
import { tryNavigateSequence, tryNavigateTo } from '../../actions/navigation';
import { selectExtra, selectStation, updateRestrictedTimeSlots } from '../../actions/station';
import { getLocationName } from '../../selectors/bookingLocation';
import { getGeneralizedItems, getNumSelectedStations } from '../../selectors/station';
import StationSelection from './StationSelection';
import { findSelectedSequencePopups } from '../../selectors/sequence';
import { AppStep } from '../../reducers/navigation';
import { tryResetApp } from '../../actions';

const mapStateToProps = (state) => ({
  // stationData: state.station,
  generalizedItems: getGeneralizedItems(state.station),
  locationName: state.bookingLocation.selectedLocation ? getLocationName(state.bookingLocation.selectedLocation) : '',
  selectedDate: state.date.selectedDate || new Date(),
  selectedStations: state.station.selectedStations,
  selectedExtras: state.station.selectedExtra,
  languageObj: state.language.station_selection_js,
  totalStations: getNumSelectedStations(state.station),
  popups: findSelectedSequencePopups(state, AppStep.Station),
  isExtraLife: state.date.isExtraLife,
  restrictedTimeSlots: state.station.restrictedTimeSlots
});

const mapDispatchToProps = (dispatch) => ({
  selectStation: (timeslotId, itemId, quantity) => dispatch(selectStation(timeslotId, itemId, quantity)),
  selectExtra: (timeslotId, itemId, quantity) => dispatch(selectExtra(timeslotId, itemId, quantity)),
  transitionBack: () => dispatch(tryNavigateSequence(false)),
  transitionToDate: () => dispatch(tryNavigateTo(AppStep.Date)),
  transitionForward: () => dispatch(tryNavigateSequence(true)),
  resetApp: () => dispatch(tryResetApp()),
  updateRestrictedStations: (restrictedTimes) => dispatch(updateRestrictedTimeSlots(restrictedTimes))
});

export default connect(mapStateToProps, mapDispatchToProps)(StationSelection);
